import { useCallback } from 'react';
import { useBreakpoint } from '@fiverr-private/hooks';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { getContext } from '@fiverr-private/fiverr_context';
import {
    reportVerticalFlowButtonClickEvent,
    reportVerticalFlowComponentClickEvent,
    reportVerticalFlowComponentImpressionEvent,
} from '../utils/mixpanel';

export const useVerticalFlowEvents = (componentName: string) => {
    const breakpoint = useBreakpoint();
    const { locale, country } = getContext();

    const [impressionRef] = useImpressionItem({
        sendImpressionToBQ: false,
        intersectionThreshold: 0.01,
        onImpression: () =>
            reportVerticalFlowComponentImpressionEvent(componentName, breakpoint || 'default', locale, country),
    });

    const reportClickEvent = useCallback(() => {
        reportVerticalFlowComponentClickEvent(componentName, breakpoint || 'default', locale, country);
    }, [componentName, breakpoint, locale, country]);

    const reportButtonClickEvent = useCallback(
        (cannedMessageName?: string) => {
            reportVerticalFlowButtonClickEvent(componentName, breakpoint || 'default', cannedMessageName);
        },
        [componentName, breakpoint]
    );

    return { impressionRef, reportClickEvent, reportButtonClickEvent };
};
